import React from 'react';
import '../styles/localAttractions.css';

const LocalAttractions = ({ language }) => {
  return (
    <section className="local-attractions-section py-5">
      <div className="container">
        <h2 className="text-center mb-2 fw-bold local-attractions-title">
          {language === 'en' ? 'Local Attractions' : 'የአካባቢ መዝናኛ ቦታዎች'}
        </h2>
        <div className="local-attractions-underline mx-auto mb-4" />

        <div className="row g-4 justify-content-center">
          <div className="col-md-6">
            <div className="local-attractions-card h-100">
              <div className="d-flex align-items-center mb-3">
                <span className="local-attractions-icon me-2">✈️</span>
                <h3 className="local-attractions-card-title mb-0">
                  {language === 'en' ? 'Arrivals' : 'መድረሻዎች'}
                </h3>
              </div>
              <ul className="local-attractions-list">
                <li>Bole International Airport - 19 min (8.7 km)</li>
                <li>Africa Union Headquarters - 9 min (650 m)</li>
                <li>Unity Park - 13 min (6.1 km)</li>
                <li>Entoto Park - 31 min (12.0 km)</li>
                <li>Science Museum - 12 min (4.8 km)</li>
              </ul>
            </div>
          </div>

          <div className="col-md-6">
            <div className="local-attractions-card h-100">
              <div className="d-flex align-items-center mb-3">
                <span className="local-attractions-icon me-2">📍</span>
                <h3 className="local-attractions-card-title mb-0">
                  {language === 'en' ? 'Attractions' : 'መዝናኛ ቦታዎች'}
                </h3>
              </div>
              <ul className="local-attractions-list">
                <li>kaizen institute - 10 m</li>
                <li>International Evangelical Church - 600 m</li>
                <li>Lafto Mall - 3.1 km</li>
                <li>Karls Square - 1.2 km</li>
                <li>Fikre Kunspagna - 2.1 km</li>
                <li>Africa Beza University College - 1.4 km</li>
                <li>Pushkin Square - 1.5 km</li>
                <li>Zetseat Apostolic Reformation Church - 1.5 km</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocalAttractions;
